



























import { Vue, Component } from 'vue-property-decorator';
import { getRange } from '@/libs/time';
import MyTodoServices from '@/services/mytodo';
import TodoTab1 from './todo-tab1.vue';
import TodoTab2 from './todo-tab2.vue';
import TodoTab3 from './todo-tab3.vue';
import MenuMixin from '@/mixins/menu-mixin';
import { mixins } from 'vue-class-component';
@Component({
  components: { TodoTab1, TodoTab2, TodoTab3 }
})
export default class Todo extends mixins(MenuMixin) {
  todoSrv = new MyTodoServices();
  bread = [{ name: '我的工作台' }, { name: '我的待办' }];
  activeKey = 1;
  handleCount = 0;
  reviewCount = 0;
  approveCount = 0;

  created() {
    this.syncCount();
  }

  /**
   * 页面初始化时获取非活动状态标签页的角标数据
   */
  async syncCount() {
    let [startTime, endTime] = getRange('week');
    let reviewCountRecord = await this.todoSrv.getReviewCount({ startTime, endTime });
    this.reviewCount = reviewCountRecord.count1;
    let approveCountRecord = await this.todoSrv.getApproveCount({ startTime, endTime });
    this.approveCount = approveCountRecord.total1;
  }

  /**
   * 更新角标数字
   */
  update(key: string, value: number) {
    switch (key) {
      case 'handle':
        this.handleCount = value;
        break;
      case 'review':
        this.reviewCount = value;
        break;
        break;
      case 'approve':
        this.approveCount = value;
        break;
      default:
        break;
    }
  }
}
